import mutations from "@/store/mutations/routerMutation";
import getters from "@/store/getters/routerGetter";
import actions from "@/store/actions/routerAction";
/**
 * [GX] router
 */
export default {
  state: {
    routeStack: []
  },
  actions,
  mutations,
  getters
};
